import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9 3.417A5.91 5.91 0 004.645 5.3a.78.78 0 01-1.059.064.68.68 0 01-.07-1A7.472 7.472 0 019 2c4.025 0 7.27 3.11 7.349 6.942l.365-.354a.782.782 0 011.06-.008c.297.27.302.716.012 1l-1.65 1.593a.78.78 0 01-1.072 0l-1.65-1.594a.677.677 0 01.012-.999.782.782 0 011.06.008l.362.347C14.768 5.86 12.165 3.417 9 3.417zM2.4 6.78a.78.78 0 01.536.213l1.65 1.594c.29.283.284.73-.012.998a.782.782 0 01-1.06-.007l-.362-.347C3.232 12.306 5.835 14.75 9 14.75a5.91 5.91 0 004.355-1.884.78.78 0 011.059-.064.68.68 0 01.07.999A7.472 7.472 0 019 16.167c-4.025 0-7.27-3.11-7.349-6.942l-.365.354a.782.782 0 01-1.06.007.677.677 0 01-.012-.998l1.65-1.594A.78.78 0 012.4 6.78z",
		fillRule: "evenodd"
	})
});
export default SvgReload;
